module.exports = __webpack_public_path__ + "img/menuimg1.77278981.png";